<div class="flex d-flex justify-content-center">
    <!-- <button mat-dialog-close class="ml-auto"><mat-icon mat-dialog-close >close</mat-icon></button> -->
    <button mat-dialog-close  class="SLV2-popup-close-btn">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
    </button>
</div>
<!-- mat-dialog-content -->
<div class="dg-image">
    <img src="{{ dialogData.titleMedia }}"/>
</div>
